const parseContentDisposition = (
    contentDispositionHeaderValue: string
): string => {
    // First, try to get the filename from the extended format (filename*)
    const extendedMatch = /filename\*=UTF-8''(.+)/i.exec(
        contentDispositionHeaderValue
    );
    if (extendedMatch && extendedMatch[1]) {
        return decodeURIComponent(extendedMatch[1]);
    }

    // If extended format is not found, try the standard format
    const standardMatch = /filename="?(.+?)"?(?:;|$)/i.exec(
        contentDispositionHeaderValue
    );
    if (standardMatch && standardMatch[1]) {
        return standardMatch[1];
    }

    // If no filename is found, return a default
    return 'download';
};

export default parseContentDisposition;
